import { API_TOKEN_STORAGE } from '@/config';

export default class ManageTokenService {
  static addTokenToStorage(token) {
    API_TOKEN_STORAGE.setItem('token', token);
  }

  static removeTokenFromStorage() {
    API_TOKEN_STORAGE.clear();
  }

  static getTokenFromStorage() {
    return API_TOKEN_STORAGE.getItem('token');
  }
}



// WEBPACK FOOTER //
// ./src/services/ManageTokenService.js